import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import App from './App';
import theme from './theme';

// Import consolidated CSS file
// Note: Fonts are now preloaded and defined in index.html for better performance
import './styles/styles.css';

// Debug helper
if (process.env.NODE_ENV === 'production') {
  const originalError = console.error;
  console.error = (...args) => {
    if (args[0]?.includes('createContext')) {
      console.log('Context Creation Error Details:', {
        args,
        stack: new Error().stack
      });
    }
    originalError.apply(console, args);
  };
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ChakraProvider theme={theme} resetCSS>
      <App />
    </ChakraProvider>
  </React.StrictMode>
);
